import { formatCurrency, getInitial } from './AuctionSharedUtils';

const getEmptyState = (status) => {
  if (status === 'completed') return 'Auction completed.';
  if (status === 'paused') return 'Auction is paused.';
  if (status === 'running') return 'Waiting for next player.';
  return 'Waiting for auction to start.';
};

const AuctionCurrentPlayerCard = ({ auction = {}, currentPlayer }) => {
  const playerName = currentPlayer?.playerName || currentPlayer?.name || '';
  const hasPlayer = Boolean(playerName);
  const latestBid = auction.latestBid || {};
  const bidAmount = latestBid.amount ?? currentPlayer?.currentBid ?? currentPlayer?.basePrice;
  const leadingTeam = latestBid.teamName || currentPlayer?.currentTeam?.name || '';

  return (
  <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
    <div style={{ height: 4, background: 'linear-gradient(90deg, #f59e0b, #f97316)' }} />
    <div className="card-body p-4">
      <div className="fw-semibold mb-3">Current Live State</div>
      {hasPlayer ? (
        <div className="row g-4 align-items-center">
          <div className="col-12 col-lg-6"><div className="d-flex align-items-center gap-3">{currentPlayer.image ? <img src={currentPlayer.image} alt={playerName} className="rounded-circle border" style={{ width: 78, height: 78, objectFit: 'cover' }} /> : <div className="rounded-circle border d-flex align-items-center justify-content-center bg-light" style={{ width: 78, height: 78, fontSize: 24, fontWeight: 700 }}>{getInitial(playerName, 'P')}</div>}<div><div className="small text-uppercase text-muted fw-semibold mb-1">Current Player</div><div className="h5 mb-1">{playerName}</div><div className="text-muted">{currentPlayer.role || 'Player'}</div></div></div></div>
          <div className="col-6 col-lg-3"><div className="rounded-4 border bg-light-subtle p-3 h-100"><div className="small text-muted fw-semibold text-uppercase mb-2">Current Bid</div><div className="fw-bold" style={{ fontSize: '1.4rem', color: '#0f172a' }}>{formatCurrency(bidAmount)}</div></div></div>
          <div className="col-6 col-lg-3"><div className="rounded-4 border bg-light-subtle p-3 h-100"><div className="small text-muted fw-semibold text-uppercase mb-2">Leading Team</div><div className="fw-bold" style={{ fontSize: '1rem', color: '#0f172a' }}>{leadingTeam || 'No bids yet'}</div></div></div>
        </div>
      ) : <div className="rounded-4 border bg-light-subtle p-4 text-center text-muted">{getEmptyState(auction.status)}</div>}
    </div>
  </div>
  );
};

export default AuctionCurrentPlayerCard;
